exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueTables__search__input {\n  width: 250px !important;\n}\n.VuePagination {\n  margin-top: 10px;\n}\n", ""]);

// exports
